import { WIS_RPC_COMMANDS } from '../constants';

/**
 * Check if the mic is muted or not
 * @return {{mic: (string), command: string}}
 */
export default function getCurrentAudioStatus() {

    const { startWithAudioMutedWildix } = APP.store.getState()['wildix/customStorageSettings'];

    return {
        command: WIS_RPC_COMMANDS.TALKING,
        mic: startWithAudioMutedWildix ? WIS_RPC_COMMANDS.MUTE : WIS_RPC_COMMANDS.UNMUTE
    };
}
